import { render, staticRenderFns } from "./AccountsDetails.vue?vue&type=template&id=d1bd9f7a&scoped=true&"
import script from "./AccountsDetails.vue?vue&type=script&lang=ts&"
export * from "./AccountsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AccountsDetails.vue?vue&type=style&index=0&id=d1bd9f7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bd9f7a",
  null
  
)

export default component.exports